import { CadI18nService } from './CadI18nService'

/** 全局 CAD 国际化服务单例，供 CAD.setTranslator/resetTranslator 和容器内部共享 */
export const globalCadI18n = new CadI18nService()
